import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./Invoice.css";
import Logo from '../Assets/pdf-header.jpg';
import { FaBarcode } from "react-icons/fa";

const Invoice = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const order_id = params.get("order_id");
  const [orderData, setOrderData] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_ADMIN_API_BASE_URL;
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (!order_id) return;

    const fetchOrderDetails = async () => {
      try {
        const response = await axios.post(
          // `${API_BASE_URL}order_details.php`,
          `https://dharshancrackers.com/admin_api/order_details.php`,
          { order_id }
        );

        if (response.data.head.code === 200) {
          setOrderData(response.data.body);
        } else {
          console.error("Failed to fetch order details");
        }
      } catch (error) {
        console.error("Error fetching order details:", error);
      }
    };

    fetchOrderDetails();
  }, [order_id, API_BASE_URL]);

  useEffect(() => {
    if (orderData && imageLoaded) {
      setTimeout(() => {
        window.print();
      }, 300);
    }
  }, [orderData, imageLoaded]);

  if (!orderData) {
    return <p>Loading...</p>;
  }

  // Helper to format currency
  const formatCurrency = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return "₹0.00";
    return `₹${num.toFixed(2)}`;
  };

  // Calculate Net Total (Subtotal - Discount)
  const calculateNetTotal = () => {
    const subtotal = parseFloat(orderData.subtotal) || 0;
    const discount = parseFloat(orderData.discount_amt) || 0;
    const netTotal = subtotal - discount;
    return formatCurrency(netTotal);
  };

  // Calculate grand total with rounding
  const getGrandTotal = () => {
    const total = parseFloat(orderData.total);
    if (isNaN(total)) return "₹0.00";
    const rounded = total % 1 >= 0.5 ? Math.ceil(total) : Math.floor(total);
    return `₹${rounded.toFixed(2)}`;
  };

  return (
    <>
      <div className="watermark">Dharshan Crackers</div>
      <div className="invoice-wrapper">
        <div className="invoice-container">
          <table className="invoice-table">
            <tbody>
              {/* Header with Logo */}
              <tr>
                <td className="invoice-header">
                  <img
                    src={Logo}
                    alt="Company Logo"
                    onLoad={() => setImageLoaded(true)}
                  />
                </td>
              </tr>

              {/* Order Info */}
              <tr>
                <td className="order-info">
                  <div className="order-row">
                    <span>Order ID: {orderData.order_id}</span>
                    <span>Date: {orderData.orderdate}</span>
                  </div>
                </td>
              </tr>

              {/* Billing & Shipping */}
              <tr>
                <td className="billing-shipping">
                  <div className="billing">
                    <h3>Billing Information</h3>
                    <p>{orderData.billing_name}</p>
                    <p>
                      {orderData.billing_address}, {orderData.billing_city},{" "}
                      {orderData.billing_state}, {orderData.billing_pincode}
                    </p>
                    <p><strong>Mobile:</strong> {orderData.mobile}</p>
                    <p><strong>Email:</strong> {orderData.email}</p>
                    <p><strong>Coupon Code:</strong> {orderData.coupen_code}</p>
                  </div>
                </td>
              </tr>

              {/* Product Table - Aligned with Thanks page */}
              <tr>
                <td className="products-section">
                  <table className="product-table-invoice">
                    <thead>
                      <tr>
                        <th className="col-sno">S.No</th>
                        {/* <th className="col-product-code">Code</th> */}
                        <th className="col-product">Product Name</th>
                        <th className="col-qty">Qty</th>
                        <th className="col-price">Price</th>
                        <th className="col-total">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderData.order_details.map((item, index) => (
                        <tr key={index}>
                          <td className="col-sno">{index + 1}</td>
                          {/* <td className="col-product-code">
                            {item.product_code ? (
                              <span className="product-code-badge">
                                <FaBarcode className="print-breadcrumb-icon" /> {item.product_code}
                              </span>
                            ) : (
                              '—'
                            )}
                          </td> */}
                          <td className="col-product">{item.product_name}</td>
                          <td className="col-qty">{item.qty}</td>
                          <td className="col-price">{formatCurrency(item.amount)}</td>
                          <td className="col-total">{formatCurrency(item.totalamount)}</td>
                        </tr>
                      ))}

                      {/* Sub Total */}
                      <tr className="summary-row">
                        <td colSpan="4" className="summary-label">
                          <b>Sub-Total</b>
                        </td>
                        <td className="summary-value">
                          {formatCurrency(orderData.subtotal)}
                        </td>
                      </tr>

                      {/* Discount */}
                      {orderData.discount_amt > 0 && (
                        <tr className="discount-row">
                          <td colSpan="4" className="summary-label">
                            <b>Discount ({orderData.discount_percentage || 0}%)</b>
                          </td>
                          <td className="summary-value discount-value">
                            -{formatCurrency(orderData.discount_amt)}
                          </td>
                        </tr>
                      )}

                      {/* NET TOTAL - NEW ROW */}
                      <tr className="nettotal-row">
                        <td colSpan="4" className="summary-label">
                          <b className="nettotal-text">Net Total</b>
                        </td>
                        <td className="summary-value nettotal-value">
                          <b className="nettotal-amount">{calculateNetTotal()}</b>
                        </td>
                      </tr>

                      {/* Packing Charges */}
                      {orderData.packing_amt > 0 && (
                        <tr className="packing-row">
                          <td colSpan="4" className="summary-label">
                            <b>Packing ({orderData.packing_percentage || 0}%)</b>
                          </td>
                          <td className="summary-value">
                            {formatCurrency(orderData.packing_amt)}
                          </td>
                        </tr>
                      )}

                      {/* CGST */}
                      {Number(orderData.cgst_amt) > 0 && (
                        <tr className="tax-row">
                          <td colSpan="4" className="summary-label">
                            <b>CGST</b>
                          </td>
                          <td className="summary-value">
                            {formatCurrency(orderData.cgst_amt)}
                          </td>
                        </tr>
                      )}

                      {/* SGST */}
                      {Number(orderData.sgst_amt) > 0 && (
                        <tr className="tax-row">
                          <td colSpan="4" className="summary-label">
                            <b>SGST</b>
                          </td>
                          <td className="summary-value">
                            {formatCurrency(orderData.sgst_amt)}
                          </td>
                        </tr>
                      )}

                      {/* Grand Total */}
                      <tr className="grandtotal-row">
                        <td colSpan="4" className="grandtotal-label">
                          <b>Grand Total</b>
                        </td>
                        <td className="grandtotal-value">
                          <b>{getGrandTotal()}</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <p className="footer-message">This Estimate is Valid For 3 Days Only</p>
          <p className="footer-message diwali">Happy Diwali... Safety Diwali...</p>
        </div>
      </div>
    </>
  );
};

export default Invoice;